<template>
  <div class="mt-1">
    <div>
      <b-tabs content-class="pt-1" lazy v-model="tabIndex">
        <b-tab
          v-for="(tab, index) in tabs"
          :key="index"
          @click="onTabClick(tab, index)"
          :title="tab.text"
          :active="active(index)"
          title-item-class="lisaweb"
        >
          <keep-alive>
            <component :is="selected"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import InsuranceAncillaries from "@/components/lisapay/insurance-ancillaries/index.vue";
import ReducedDeferred from "@/components/lisapay/reduced-deferred/index.vue";
import ShortcutsAndBreadcrumbsMixin from "@/mixins/ShortcutsAndBreadcrumbsMixin";

export default {
  mixins: [ShortcutsAndBreadcrumbsMixin],
  data() {
    return {
      path: "lisapay",
      tabs: [
        { name: "InsuranceAncillaries", text: "Titoli" },
        { name: "ReducedDeferred", text: "Recupero Sospesi" },
      ],
      tabsGroup: "Management",
      // breadcrumbs settings: bcs & maxLevel
      bcs: [
        {
          text: "Lisapay",
          path: "",
          level: 0,
          disabled: true,
        },
        {
          text: "Lisapay",
          path: "",
          level: 1,
        },
        {
          text: "Titoli",
          path: "lisapay",
          tab: `#${this.selected}`,
          level: 2,
        },
      ],
      maxLevel: 2, // use to identify the tabs level
      selected: "InsuranceAncillaries",
      tabIndex: 0,
      // isLoading: false,
    };
  },
  components: {
    InsuranceAncillaries,
    ReducedDeferred,
  },
};
</script>